import * as Yup from "yup";
import { buildMaxErrorMessage, buildErrorMsg } from "component-library";
import { IJoiningPagesCommon } from "translations/src/models/joining-pages/Common";
import { IUploadHeadshotModalTranslations } from "translations/src/models/joining-pages/AboutYouPage";

import { MB } from "../../../../../constants/Size";

export const acceptedHeadshotFileTypes = [
  ".jpg",
  ".jpeg",
  ".bmp",
  ".tif",
  ".tiff",
];

export const HEADSHOT_MIN_WIDTH = 500;

export const HEADSHOT_MIN_HEIGHT = 500;

export const HEADSHOT_MAX_SIZE = 40 * MB;

export const createUploadImageSchema = (
  fieldNames: IUploadHeadshotModalTranslations,
  common: IJoiningPagesCommon
) => {
  const { entryRequired, entryMaxLength } = common.errorsCommon;

  return Yup.object().shape({
    photographerName: Yup.string()
      .trim()
      .max(
        50,
        buildMaxErrorMessage(
          entryMaxLength,
          fieldNames.photographerNameLabel,
          50
        )
      )
      .required(buildErrorMsg(entryRequired, fieldNames.photographerNameLabel))
      .not([null])
      .typeError(
        buildErrorMsg(entryRequired, fieldNames.photographerNameLabel)
      ),
    description: Yup.string()
      .trim()
      .max(
        255,
        buildMaxErrorMessage(
          entryMaxLength,
          fieldNames.photoDescriptionLabel,
          255
        )
      ),
  });
};
